import { MapPin, ChevronRight } from 'lucide-react';
import { getCategory, type Listing } from '../directory/data';

export function ListingCard({ listing }: { listing: Listing }) {
  const cat = getCategory(listing.category);
  return (
    <a
      href={`/discover/${listing.category}/${listing.slug}`}
      className="block rounded-card bg-card p-5 shadow-card transition-transform hover:-translate-y-0.5"
    >
      <div className="flex items-center gap-1.5 text-xs font-medium text-muted">
        {cat ? cat.icon({ className: 'size-4' }) : null}
        <span>{cat?.label}</span>
      </div>
      <p className="mt-2 font-medium text-ink">{listing.name}</p>
      <p className="mt-1 flex items-center gap-1 text-sm text-muted">
        <MapPin className="size-3.5" /> {listing.area}, {listing.city}
      </p>
      <p className="mt-2 line-clamp-2 text-sm text-ink-soft">{listing.summary}</p>
      <span className="mt-3 inline-flex items-center gap-1 text-sm font-medium text-ink-soft">
        View <ChevronRight className="size-4" />
      </span>
    </a>
  );
}
